const sort = function(toSort, column, direction) {
  if (!direction) {
    direction = 'asc';
  }

  return toSort.sort(function(a, b) {
    const columnA = getValue(a, column);
    const columnB = getValue(b, column);

    if (columnA > columnB) {
      return direction === 'asc' ? 1 : -1;
    } else if (columnA < columnB) {
      return direction === 'asc' ? -1 : 1;
    } else if (columnA === columnB) {
      return 0;
    }
  });
};

const getValue = function(object, column) {
  const nested = column.split('.');

  nested.forEach(key => {
    object = object[key];
  });

  return object
    ? typeof object === 'number'
      ? object
      : object.toLowerCase()
    : '';
};

export default sort;
